<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/valid-v-for -->
<template>
  <div id="sidebar" class="sidebar" :style="{ backgroundColor: coloreSfondo }">
    <SidebarHeader />
    <SidebarForm />
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <template v-for="(item, index) in navItems" v-if="navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper"
              :style="{ color: coloreTitoli }"
            />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class" />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown :name="item.name" :state="item.state" :icon="item.icon">
                <template v-for="(childL1, index) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      :name="childL1.name"
                      :state="childL1.state"
                      :icon="childL1.icon"
                    >
                      <li v-for="(childL2, index) in childL1.children" class="nav-item">
                        <SidebarNavLink
                          :name="childL2.name"
                          :state="childL2.state"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="item.variant"
                          :project-id="item.projectId"
                          :modality="item.modality"
                        />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :state="childL1.state"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="item.variant"
                        :project-id="item.projectId"
                        :modality="item.modality"
                      />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :state="item.state"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant"
                  :project-id="item.projectId"
                  :modality="item.modality"
                />
              </SidebarNavItem>
            </template>
          </template>
        </template>
        <!--
        <div class="logout_spate">
          <button
            :style="{
              backgroundColor: coloreBottone,
              borderColor: coloreBordoBottone,
              color: coloreTestoBottone
            }"
            type="submit"
            name="loginForm"
            value="check"
            class="btn btn-lg btn-success"
            @click="onClickLogout"
          >
            Logout
          </button>
        </div>
        -->
      </ul>
      <slot></slot>
    </nav>
    <div v-if="bBannerVisible">
      <a :href="bannerInfo.link" target="_blank">
      <img class="img" :src="'data:image/png;base64,' + bannerInfo.image" />
      </a>
    </div>
    <div v-if="bLogoVisibile">
      <img class="img" :src="'static/img/logo_colonna.png'" />
    </div>
    <SidebarFooter />
    <!--<SidebarMinimizer/>-->
  </div>
</template>
<script>
import SidebarFooter from "./SidebarFooter";
import SidebarForm from "./SidebarForm";
import SidebarHeader from "./SidebarHeader";
import SidebarMinimizer from "./SidebarMinimizer";
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import colorsService from "../../services/backend/colorsService";
import generalService from "../../services/backendCipriani/generalService";
import Cookies from "js-cookie";

export default {
  name: "Sidebar",
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      coloreSfondo: "",
      coloreTitoli: "",
      coloreBottone: "",
      coloreBordoBottone: "",
      coloreTestoBottone: "",
      bLogoVisibile: false,
      bBannerVisible: false,
      bannerInfo: {}
    };
  },
  mounted: function() {
    var that = this;
    //colorsService.getColoriSidebar().then(function(data) {
    var colorList = colorsService.getColoriSidebar();
    that.coloreSfondo = colorList[0];
    that.coloreTitoli = colorList[2];
    that.coloreBottone = colorList[3];
    that.coloreBordoBottone = colorList[5];
    that.coloreTestoBottone = colorList[6];
    //});

    generalService.getLogoVisibility().then(function(data) {
      that.bLogoVisibile = data;
    });

    generalService.getBannerInfo().then(data => {
      that.bBannerVisible = data.image.length > 0 && data.image.link != "";

      that.bannerInfo = data;
    });
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
    onClickLogout() {
      Cookies.remove("loginToken");
      // reload page
      this.$router.go();
    }
  }
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}

.img {
  padding: 16px;
  margin: auto;
  width: 100%;
}

.logout_spate {
  padding: 0 16px;
  margin: auto 0 16px;
}
.logout_spate > .btn {
  width: 100%;
}
</style>
